import memoize from 'memoizee';
import { arrayToHashmap } from '@/utils/Array';

// Gauges that aren't linked to pools, only hardcoded here to avoid side-effects
// everywhere else that expects a gauge to be for a pool
const HARDCODED_NOT_POOL_GAUGES = {
    'fundraising-gauge-vyper': {
        gauge: '0xbAF05d7aa4129CA14eC45cC9d4103a9aB9A9fF60',
        name: 'Fundraising Gauge (Vyper)',
        isNotForPool: true,
    },
};

const getGaugesData = memoize(async () => (
    (await (await fetch('https://api.curve.fi/api/getAllGauges')).json()).data
), {
    promise: true,
    maxAge: 60 * 1000, // 1 min
});


const getAllGauges = async (withSpecialGauges = true) => ({
    ...(await getGaugesData()),
    ...(withSpecialGauges ? HARDCODED_NOT_POOL_GAUGES : {}),
});

const getGaugesAddressToNameMap = memoize(async (
    onlyEthereumGauges = false,
    excludeKilledGauges = false,
    withSpecialGauges = true
) => {
    const gaugesData = Array.from(Object.values(await getAllGauges(withSpecialGauges))).filter(({ sideGauge, hasNoCrv }) => !sideGauge && !hasNoCrv);
    const filteredGauges = onlyEthereumGauges ?
        gaugesData.filter(({ side_chain }) => !side_chain) :
        gaugesData;
    const filteredGauges2 = excludeKilledGauges ?
        filteredGauges.filter(({ is_killed }) => !is_killed) :
        filteredGauges;

    return arrayToHashmap(filteredGauges2.map(({ gauge: address, name }) => [
        address,
        name,
    ]));
}, {
    promise: true,
    maxAge: 60 * 1000, // 1 min
    length: 3,
});

const getGaugesAddresses = memoize(async (withSpecialGauges = true) => {
    const gaugesData = await getAllGauges(withSpecialGauges);
    return Array.from(Object.values(gaugesData)).filter(({ sideGauge, hasNoCrv }) => !sideGauge && !hasNoCrv).map(({ gauge: address }) => address);
}, {
    promise: true,
    maxAge: 60 * 1000, // 1 min
    length: 1,
});

const getGaugeDataForAddress = memoize(async (address, withSpecialGauges = true) => {
    const gaugesData = await getAllGauges(withSpecialGauges);
    const lcAddress = address.toLowerCase();

    return Array.from(Object.values(gaugesData)).filter(({ sideGauge, hasNoCrv }) => !sideGauge && !hasNoCrv).find(({ gauge: address }) => address.toLowerCase() === lcAddress);
}, {
    promise: true,
    maxAge: 60 * 1000, // 1 min
    length: 2,
});

export default getAllGauges;
export {
    getGaugesAddressToNameMap,
    getGaugesAddresses,
    getGaugeDataForAddress,
};
